import { Flex } from '@chakra-ui/layout';
import { chakra } from '@chakra-ui/system';

export const container = chakra(Flex, {
    label: 'video-thumbnail-container',
    baseStyle: {
        fontFamily: 'Poppins, sans-serif',
        w: '276px',
        h: '82px',
        borderRadius: '12px',
        backgroundColor: '#345',
        fontWeight: 400,
        fontSize: '16px',
        color: '#fff',
        lineHeight: '22.88px',
        letterSpacing: '-0.15px',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'inset 0 0 0 1000px rgba(0,0,0,.7)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        overflow: 'visible',
        border: '2px solid #fff'
    }
});

export const wrapper = chakra(Flex, {
    label: 'video-thumbnail-wrapper',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        w: '280px',
        h: '86px',
        m: '0 0 12px 0',
        borderRadius: '12px',
        _hover: { border: '2px solid #00ABE8' }
    }
});
